function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTypescript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,47.843137%,80%)",
      fillOpacity: 1
    },
    d: "M 3.644531 13.5 L 3.644531 23.355469 L 23.355469 23.355469 L 23.355469 3.644531 L 3.644531 3.644531 Z M 3.644531 13.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.003906 13.566406 L 7.996094 14.367188 L 10.566406 14.367188 L 10.566406 21.660156 L 12.382812 21.660156 L 12.382812 14.367188 L 14.949219 14.367188 L 14.949219 13.574219 C 14.949219 13.136719 14.9375 12.769531 14.925781 12.761719 C 14.914062 12.75 13.355469 12.742188 11.464844 12.742188 L 8.019531 12.753906 Z M 8.003906 13.566406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.546875 12.738281 C 20.050781 12.863281 20.425781 13.082031 20.777344 13.453125 C 20.964844 13.644531 21.226562 13.996094 21.25 14.082031 C 21.253906 14.109375 20.394531 14.683594 19.878906 15.007812 C 19.863281 15.015625 19.785156 14.9375 19.699219 14.8125 C 19.445312 14.445312 19.179688 14.28125 18.777344 14.257812 C 18.175781 14.214844 17.792969 14.527344 17.796875 15.050781 C 17.796875 15.203125 17.820312 15.292969 17.886719 15.417969 C 18.015625 15.6875 18.261719 15.855469 19.023438 16.183594 C 20.433594 16.789062 21.039062 17.195312 21.414062 17.761719 C 21.835938 18.398438 21.929688 19.40625 21.644531 20.164062 C 21.328125 20.984375 20.550781 21.539062 19.460938 21.722656 C 19.121094 21.785156 18.324219 21.773438 17.960938 21.707031 C 17.167969 21.566406 16.414062 21.179688 15.957031 20.660156 C 15.773438 20.460938 15.421875 19.9375 15.445312 19.898438 C 15.457031 19.886719 15.535156 19.832031 15.628906 19.785156 C 15.714844 19.738281 16.050781 19.542969 16.363281 19.363281 L 16.929688 19.035156 L 17.046875 19.207031 C 17.214844 19.460938 17.578125 19.808594 17.792969 19.925781 C 18.417969 20.253906 19.28125 20.210938 19.710938 19.828125 C 19.894531 19.660156 19.96875 19.488281 19.96875 19.238281 C 19.96875 19.011719 19.941406 18.910156 19.824219 18.738281 C 19.671875 18.515625 19.359375 18.332031 18.46875 17.949219 C 17.453125 17.511719 17.015625 17.238281 16.609375 16.808594 C 16.378906 16.5625 16.160156 16.15625 16.070312 15.828125 C 15.996094 15.546875 15.976562 14.851562 16.039062 14.570312 C 16.25 13.585938 16.988281 12.902344 18.058594 12.699219 C 18.402344 12.632812 19.207031 12.652344 19.546875 12.738281 Z M 19.546875 12.738281 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.92253bc9022b40d9acc34ea978e52497.svg";
export { ForwardRef as ReactComponent };